<template>
  <nav aria-label="breadcrumb" class="col-auto">
    <ol class="breadcrumb">
      <li
        class="breadcrumb-item"
        v-for="(item, index) in breadcrumb"
        :key="'breadcrumb' + index"
      >
        {{ item }}
      </li>
    </ol>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Breadcrumb',
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['breadcrumb'])
  }
}
</script>
